import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import DayDetailView from '../../../src/components/weekly/DayDetailView';

const DayDetailScreen: React.FC = () => {
  const { date } = useLocalSearchParams<{ date: string }>();

  if (!date) return null;

  return <DayDetailView date={date} />;
};

export default DayDetailScreen;
